import React, { useState, useEffect } from "react";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import InputField from "../../admin/childComponents/inputComponents/InputField";
import TextArea from "../../admin/childComponents/inputComponents/TextArea";
import { Link } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import Loading from "../../admin/childComponents/appComponents/Loading";
import truncate from "truncate-html";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
function FeedbackFromNigeriansSection({
  downloadSection,
  sideNewSection,
  advertSection,
}) {
  const itemsPerPage = 2;
  const downloadsPerPage = 5;

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    input: {
      names: "",
      email: "",
      mobile: "",
      address: "",
      subject: "",
    },
    textArea: {
      textMessage: "",
    },
  });

  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  const refreshScreen = () => {
    setFormData({
      input: {
        names: "",
        email: "",
        mobile: "",
        address: "",
        subject: "",
      },
      textArea: {
        textMessage: "",
      },
    });
  };

  const [downloadPage, setDownloadPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const dataArray = Array.isArray(sideNewSection) ? sideNewSection : [];
  const dataDownloafArray = Array.isArray(downloadSection)
    ? downloadSection
    : [];

  let totalDownloadPages = 0,
    paginatedDownloads = [],
    totalPages = 0,
    paginatedAnnouncements = [];

  totalDownloadPages = Math.ceil(dataDownloafArray.length / downloadsPerPage);
  paginatedDownloads = dataDownloafArray.slice(
    (downloadPage - 1) * downloadsPerPage,
    downloadPage * downloadsPerPage,
  );

  totalPages = Math.ceil(dataArray.length / itemsPerPage);
  paginatedAnnouncements = dataArray.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  useEffect(() => {
    if (totalPages > 0) {
      //const randomStartPage = Math.floor(Math.random() * totalPages) + 1;
      const maxPage = Math.min(totalPages, 5);
      const randomStartPage = Math.floor(Math.random() * maxPage) + 1;
      setCurrentPage(randomStartPage);
    }
  }, [totalPages]);

  function getRandomWholeNumber(max) {
    return Math.ceil(Math.random() * max);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    // const subject = "Acknowledgment: Feedback Received";
    const formPayload = new FormData();
    formPayload.append("names", formData.input.names);
    formPayload.append("email", formData.input.email);
    formPayload.append("mobile", formData.input.mobile);
    formPayload.append("address", formData.input.address);
    formPayload.append("subject", formData.input.subject);
    formPayload.append("textMessage", formData.textArea.textMessage);
    // formPayload.append("subject", subject);
    formPayload.append("typeRequest", "FFN");

    try {
      await axios.get("/sanctum/csrf-cookie");
      const res = await axios.post(`${BASE_URL}fbdata`, formPayload);
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        refreshScreen();
      } else {
        swal("Error", res.data.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error(error);
      swal("Error", "Failed to send message", "error");
    } finally {
      setLoading(false);
    }
  };
  const TruncateHtml = (htmlString, length) => {
    return truncate(htmlString, length, { byWords: true });
  };
  if (loading) return <Loading message01="Loading..." />;
  return (
    <section id="contact" className="contact section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Feedback From Nigerians</h2>
        <p>
          <span>Got Something to Say?</span>{" "}
          <span className="description-title">Tell Us</span>
        </p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay={100}>
        <div className="row gy-4">
          {/* Left Info Panel */}
          {/* LEFT SIDEBAR: YouTube, Banner, Downloads */}
          <div className="col-lg-4" data-aos="fade-up" data-aos-delay={100}>
            {/* LATEST NEWS */}

            {paginatedAnnouncements.map((service, index) => {
              const date = new Date(service.daterqw);
              const month = date
                .toLocaleString("default", { month: "short" })
                .toUpperCase();
              const day = date.getDate();
              const year = date.getFullYear();

              return (
                <>
                  <div className="highlight-box mb-4">
                    <div className="highlight-title">MORE UPDATE</div>
                    <div className="position-relative mb-2">
                      {service.passport &&
                        service.passport !== "undefined" &&
                        service.passport !== "null" &&
                        service.passport.trim() !== "" && (
                          <>
                            <img
                              loading="lazy"
                              decoding="async"
                              src={`${BACKEND_URL}upload/${service.passport}`}
                              alt={service.title || "Image"}
                              className="img-fluid rounded"
                              style={{
                                objectFit: "cover",
                                height: "200px",
                                width: "100%",
                              }}
                            />
                          </>
                        )}

                      {service.caption && (
                        <span className="text-secondary">
                          <em className="blockquote-footer">
                            <HTMLDisplay
                              html={service.caption}
                              textNo={10}
                              type="title"
                              textSize="0.8rem"
                            />
                          </em>
                        </span>
                      )}

                      <div className="vertical-date-badge">
                        <div className="date-part">{month}</div>
                        <div className="date-divider">—</div>
                        <div className="date-part vertical-formatDate">
                          {day}
                        </div>
                        <div className="date-divider">—</div>
                        <div className="date-part">{year}</div>
                      </div>
                    </div>
                    <h4 className="text-justify text-secondary">
                      <HTMLDisplay
                        html={service.story01}
                        textNo={10}
                        type="title"
                      />
                    </h4>
                    <p
                      className="text-secondary"
                      style={{
                        fontSize: "0.95rem",
                        lineHeight: "1.6",
                        textAlign: "justify",
                      }}
                    >
                      <HTMLDisplay
                        html={service.story01}
                        textNo={30}
                        type="body"
                      />
                    </p>
                    <div className="text-end mt-2">
                      <Link
                        to={`/read/${service.id}`}
                        className="read-more-link btn btn-iceberg text-end"
                      >
                        Read More →
                      </Link>
                    </div>

                    {/* MORE UPDATE Pagination */}
                    {totalPages > 1 && (
                      <div className="btn-group mt-3">
                        <button
                          className="btn btn-dark"
                          aria-label="Go to next page"
                          onClick={() => setCurrentPage(1)}
                          disabled={currentPage === 1}
                        >
                          « First
                        </button>
                        <button
                          className="btn btn-dark"
                          aria-label="Go to next page"
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          disabled={currentPage === 1}
                        >
                          ‹ Prev
                        </button>
                        <button
                          className="btn btn-dark"
                          aria-label="Go to next page"
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next ›
                        </button>
                        <button
                          className="btn btn-dark"
                          aria-label="Go to last page"
                          onClick={() => setCurrentPage(totalPages)}
                          disabled={currentPage === totalPages}
                        >
                          Last »
                        </button>
                      </div>
                    )}
                  </div>
                </>
              );
            })}

            {/* ADVERTS */}
            {advertSection.length > 0 && (
              <div className="highlight-box mb-4">
                <div className="highlight-title">AWARENESS ZONE</div>
                {advertSection[getRandomWholeNumber(advertSection.length)]
                  .passport &&
                  advertSection[getRandomWholeNumber(advertSection.length)]
                    .passport !== "undefined" &&
                  advertSection[getRandomWholeNumber(advertSection.length)]
                    .passport !== "null" &&
                  advertSection[
                    getRandomWholeNumber(advertSection.length)
                  ].passport.trim() !== "" && (
                    <>
                      <img
                        loading="lazy"
                        decoding="async"
                        src={`${BACKEND_URL}upload/${
                          advertSection[
                            getRandomWholeNumber(advertSection.length)
                          ].passport
                        }`}
                        alt="Ad Banner"
                        className="img-fluid rounded"
                      />
                    </>
                  )}
              </div>
            )}

            {/* DOWNLOADS */}
            <div className="highlight-box mb-4">
              <div className="highlight-title">Downloadable Resources</div>
              <ul className="list-unstyled mb-0">
                {paginatedDownloads.map((file, i) => (
                  <li>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-file-arrow-down me-2"></i>
                      <Link
                        className="text-capitalize"
                        to={`${BACKEND_URL}upload/${file.addressLink}`}
                        download
                      >
                        <span className=" text-capitalize">
                          {TruncateHtml(file.title, 12)}
                        </span>
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
              {/* Download Pagination */}
              <div className="btn-group mt-3">
                <button
                  className="btn btn-dark"
                  aria-label="Go to next page"
                  onClick={() => setDownloadPage(1)}
                  disabled={downloadPage === 1}
                >
                  « First
                </button>
                <button
                  className="btn btn-dark"
                  aria-label="Go to next page"
                  onClick={() => setDownloadPage((p) => p - 1)}
                  disabled={downloadPage === 1}
                >
                  ‹ Prev
                </button>
                <button
                  className="btn btn-dark"
                  aria-label="Go to next page"
                  onClick={() => setDownloadPage((p) => p + 1)}
                  disabled={downloadPage === totalDownloadPages}
                >
                  Next ›
                </button>
                <button
                  className="btn btn-dark"
                  aria-label="Go to last page"
                  onClick={() => setDownloadPage(totalDownloadPages)}
                  disabled={downloadPage === totalDownloadPages}
                >
                  Last »
                </button>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-8">
            <form
              onSubmit={handleSubmit}
              className="php-email-form"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              <div className="row gy-4">
                <div className="col-md-6">
                  <InputField
                    label="Your Names"
                    name="names"
                    size="14"
                    required="required"
                    value={formData.input.names}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-6">
                  <InputField
                    label="Email"
                    name="email"
                    size="14"
                    required="required"
                    value={formData.input.email}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-6">
                  <InputField
                    label="Phone Number"
                    name="mobile"
                    size="14"
                    required="required"
                    value={formData.input.mobile}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-6">
                  <InputField
                    label="Address"
                    name="address"
                    size="14"
                    required="required"
                    value={formData.input.address}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-12">
                  <InputField
                    label="Subject"
                    name="subject"
                    size="14"
                    required="required"
                    value={formData.input.subject}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-12">
                  <TextArea
                    label="Message"
                    name="textMessage"
                    size="14"
                    rows={7}
                    required="required"
                    value={formData.textArea.textMessage}
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-12 text-center">
                  {loading ? (
                    <Loading message01="Sending message..." />
                  ) : (
                    <button type="submit">Send Message</button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(FeedbackFromNigeriansSection);
